import React from 'react'
import Button from './common/Button'
import useTrans from '../hooks/trans'
import { useModal } from '../hooks/modal'
import HydropostReportCreate from './HydropostReportCreate'
import { TODAY } from '../utils/date'
import HydropostReportUpdate from './HydropostReportUpdate'

export default function HydropostItemReport({ hydropost, report, date, editable = true, onUpdate }) {
    const t = useTrans()

    const [showReportCreateModal, hideReportCreateModal] = useModal(
        <HydropostReportCreate hydropost={hydropost} date={date} onSuccess={() => {
            onUpdate()
            hideReportCreateModal()
        }} onCancel={() => {
            hideReportCreateModal()
        }} />,
    )

    const [showReportUpdateModal, hideReportUpdateModal] = useModal(
        <HydropostReportUpdate hydropost={hydropost} report={report} onSuccess={() => {
            onUpdate()
            hideReportUpdateModal()
        }} onCancel={() => {
            hideReportUpdateModal()
        }} />,
    )

    return (
        <div>
            {report && report.morningAmount ? report.morningAmount : '-'} &nbsp;

            {editable && report && TODAY === report.date ? (
                <Button
                    onClick={showReportUpdateModal}
                    text={t('change')}
                    icon="ion-md-create"
                    className="is-warning is-light is-small" />
            ) : null}

            { editable && !report ? (
                <Button
                    onClick={showReportCreateModal}
                    text={t('fill')}
                    icon="ion-md-document"
                    className="is-info is-light is-small" />
            ) : null}
        </div>

    )
}
